<template>
  <div>
    <img
      height="80"
      class="mg-b-24"
      :src="staticAssetUrl('/static/web/illustration-child1.png')"
    >

    <h6 class="page__header font-heading-30 margin-center mg-b-16">
      Yippee! {{ successMsg }} with {{ facilityName }}!
    </h6>
    <box fa-icon="calendar" :no-icon-bg="true" color="tansy"
         class="center-content sapphire-5 mg-b-16">
        {{ formatDateTime(tourData.selectedTour.start, timezone) }} {{ timeZoneAbbr }}
    </box>
    <p class="font-body-large">
      We'll send you a reminder email before {{ subMsg }} to  {{ parentEmail }}
    </p>
  </div>
</template>

<script>
import Box from '@components/box.vue';
import { staticAssetUrl } from '@utils';
import timeZoneAbbr from '../../../common/mixins/timeZoneAbbr';
import moment from 'moment-timezone';

export default {
  name: 'confirmtion',
  components: {
    Box,
  },
  props: {
    tourData: {
      type: Object,
      default() {
        return {};
      },
    },
    facilityName: {
      type: String,
    },
    bus: {
      type: Object,
      required: true,
    },
    submitStep: {
      type: Function,
      required: true,
    },
  },
  mixins: [timeZoneAbbr],
  created() {
    this.bus.$on('on-next-step', this.handleNext);
  },
  beforeUnmount() {
    this.bus.$off('on-next-step', this.handleNext);
  },
  methods: {
    staticAssetUrl,
    handleNext() {
      this.submitStep();
    },
    formatDateTime(dateTime, timezone) {
      return moment(dateTime).tz(timezone).format('LLL');
    },
  },
  computed: {
    parentEmail() {
      const { email } = this.$store.getters['user/currentParent'] || {};
      return email;
    },
    successMsg() {
      if (this.tourData.selectedTour.isOpenHouse) {
        return "You're booked for an open house";
      }
      return 'You scheduled a tour';
    },
    subMsg() {
      if (this.tourData.selectedTour.isOpenHouse) {
        return 'the open house';
      }
      return 'your tour';
    },
  },
};
</script>

<style scoped>
.margin-center {
  margin: auto;
}

.sapphire-5 {
  width: 60%;
  height: calc(var(--grid-unit));
  margin: 0 auto;
  color: var(--gray-almostBlack);
}

.mg-b-24 {
  margin-bottom: calc(var(--grid-unit) * 3);
}

.mg-b-16 {
  margin-bottom: calc(var(--grid-unit) * 2);
}

.center-content {
  justify-content: center;
}
</style>
